/**
 * @generated SignedSource<<4b1855496708bb64490a42172417f5d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BudgetSideEnum = "COST" | "REVENUE" | "%future added value";
export type useBudgetEditor_BudgetsQuery$variables = {
  side?: BudgetSideEnum | null | undefined;
  year?: number | null | undefined;
};
export type useBudgetEditor_BudgetsQuery$data = {
  readonly budgets: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type useBudgetEditor_BudgetsQuery = {
  response: useBudgetEditor_BudgetsQuery$data;
  variables: useBudgetEditor_BudgetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "side"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "year"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "side",
        "variableName": "side"
      },
      {
        "kind": "Variable",
        "name": "year",
        "variableName": "year"
      }
    ],
    "concreteType": "Budget",
    "kind": "LinkedField",
    "name": "budgets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBudgetEditor_BudgetsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBudgetEditor_BudgetsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "486154aa2be4fe7c0f84de009653c38f",
    "id": null,
    "metadata": {},
    "name": "useBudgetEditor_BudgetsQuery",
    "operationKind": "query",
    "text": "query useBudgetEditor_BudgetsQuery(\n  $side: BudgetSideEnum\n  $year: Int\n) {\n  budgets(side: $side, year: $year) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "31291d5e6a09b6ee35f8bf00fbb5c686";

export default node;
